import React from "react";
import Modal from "./Base/Modal";
import SuccessIcon from '../assets/icons/thumbs-up-success.png'

interface PropsI {
    showModal: boolean;
    onClose : ()=>void;
    note: string;
}

const SuccessModal = ({ showModal, note, onClose }: PropsI) => {
    return (
        <Modal
            showModal={showModal}
            onClose={onClose}
            className="success-modal"
        >
            <img src={SuccessIcon} alt=""/>
            <div className="success-modal__text">
                <div className="success-modal__text--head">
                    Success!
                </div>
                <div className="success-modal__text--body">
                    {note}
                </div>
            </div>
            <button className="btn btn-primary" onClick={onClose}>
                OK
            </button>
        </Modal>
    )
}
export default SuccessModal;